import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

export const abPauseSubscription: string = !IS_MOBILE_BROWSER && getFeature('ab-pause-subscription');
